import PropTypes from "prop-types";
import { createContext } from "react";
import { darken, lighten } from "@mui/material/styles";
// hooks
import useLocalStorage from "../hooks/useLocalStorage";
// theme
import palette from "../theme/palette";

// ----------------------------------------------------------------------

const PRIMARY_COLOR = [
  // DEFAULT
  {
    name: "default",
    ...palette.light.primary,
  },
  // PURPLE
  {
    name: "shop",
    lighter: "#EBD6FD",
    light: "#B985F4",
    main: "#7635dc",
    dark: "#431A9E",
    darker: "#200A69",
    contrastText: "#fff",
  },
];

SetColor.propTypes = {
  themeColor: PropTypes.string,
};
function SetColor(themeColor) {
  if (themeColor && typeof themeColor === "string" && themeColor !== "default") {
    try {
      const OTHER = { ...PRIMARY_COLOR[1] };
      OTHER.main = themeColor;
      OTHER.light = lighten(themeColor, 0.5);
      OTHER.lighter = lighten(themeColor, 0.8);
      OTHER.dark = darken(themeColor, 0.5);
      OTHER.darker = darken(themeColor, 0.8);
      return OTHER;
    } catch (error) {
      console.error("Error setting custom theme color:", error);
      return PRIMARY_COLOR[0];
    }
  }
  return PRIMARY_COLOR[0];
}

const initialState = {
  themeMode: "light",
  themeDirection: "ltr",
  themeColor: "default",
  themeStretch: false,
  onChangeMode: () => {},
  onChangeDirection: () => {},
  onChangeColor: () => {},
  onToggleStretch: () => {},
  setColor: PRIMARY_COLOR[0],
  colorOption: [],
};

const SettingsContext = createContext(initialState);

SettingsProvider.propTypes = {
  children: PropTypes.node,
};

function SettingsProvider({ children }) {
  const [settings, setSettings] = useLocalStorage("settings", {
    themeMode: initialState.themeMode,
    themeDirection: initialState.themeDirection,
    themeColor: initialState.themeColor,
    themeStretch: initialState.themeStretch,
  });

  const onChangeMode = (event) => {
    setSettings({
      ...settings,
      themeMode: event.target.value,
    });
  };

  const onChangeDirection = (event) => {
    setSettings({
      ...settings,
      themeDirection: event.target.value,
    });
  };

  const onChangeColor = (event) => {
    setSettings({
      ...settings,
      themeColor: event.target.value,
    });
  };
  const changeColor = (color) => {
    setSettings({
      ...settings,
      themeColor: color,
    });
  };
  const changeMode = (mode) => {
    setSettings({
      ...settings,
      themeMode: mode,
    });
  };

  const onToggleStretch = () => {
    setSettings({
      ...settings,
      themeStretch: !settings.themeStretch,
    });
  };

  return (
    <SettingsContext.Provider
      // eslint-disable-next-line
      value={{
        ...settings,
        // Mode
        onChangeMode,
        // Direction
        onChangeDirection,
        changeMode,
        // Color
        onChangeColor,
        changeColor,
        setColor: SetColor(settings.themeColor),
        colorOption: PRIMARY_COLOR.map((color) => ({
          name: color.name,
          value: color.main,
        })),
        // Stretch
        onToggleStretch,
      }}
    >
      {children}
    </SettingsContext.Provider>
  );
}

export { SettingsProvider, SettingsContext };
